/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import SEO from "../components/seo/seo.component"
import Header from "../components/header/header.component"
import { AppContainer } from "../styles/app.styles"
import Footer from "./footer/footer.component"
import { isBrowser } from "../utils/utils"
import FormPopup from "./form-popup/form-popup.component"

const Layout = ({ children }) => {
  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }
  useEffect(() => {
    // Function to handle the click event
    const handleClick = () => {
      setOpen(true)
    }
    if (isBrowser) {
      const buttonElement = document.getElementById("form-signup")
      if (buttonElement) {
        buttonElement.addEventListener("click", handleClick)
        return () => {
          buttonElement.removeEventListener("click", handleClick)
        }
      }
    }
  }, [])
  return (
    <>
      <Header />
      <AppContainer>{children}</AppContainer>
      <FormPopup open={open} handleClose={handleClose} />
      <ToastContainer autoClose={2000} theme="colored" />
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
